import styled from 'styled-components'
import {Box, Button, Dialog} from "@mui/material";

export const Container = styled.div`
    width: 100%;
    background: #fff;
    border: 1px solid #e7ebef;
    border-radius: 12px;
    padding: 16px;
    box-sizing: border-box;

    @media only screen and (max-width: 480px) {
        padding: 12px;
    }
`

export const PopupContainer = styled.div`
    padding: 1.5rem 1rem;
    border-radius: 8px;
    background: white;
    max-width: 25.75rem;
    width: 100%;
    align-self: center;
`

export const BottomContainer = styled(Box)`
    display: flex;
    justify-content: flex-start;
    margin-top: 0.75rem;
`

export const WarningBanner = styled(Box)<{$variant: 'snc' | 'regular' | 'grace'}>`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.95rem 1rem;
    border-radius: 10px;
    margin-bottom: 1.5rem;

    .banner-icon {
        flex-shrink: 0;
        margin-top: 0.1rem;
    }

    ${({$variant}) => {
        switch ($variant) {
            case 'snc':
                return `
                    background-color: #FFF8E1;
                    border: 1px solid #FFE082;
                    .banner-icon { color: #F9A825; }
                `;
            case 'regular':
                return `
                    background-color: #FDE8E8;
                    border: 1px solid #FFCDD2;
                    .banner-icon { color: #FB7672; }
                `;
            case 'grace':
                return `
                    background-color: #E8F5E9;
                    border: 1px solid #A5D6A7;
                    .banner-icon { color: #13CA82; }
                `;
        }
    }}
`

export const ShiftDetailsCard = styled(Box)`
    background: #f8fafb;
    border: 1px solid #edf1f4;
    border-radius: 10px;
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;

    .detail-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.35rem 0;

        .detail-label {
            color: rgba(0, 0, 0, 0.55);
            font-size: 0.85rem;
        }

        .detail-value {
            color: rgba(0, 0, 0, 0.87);
            font-size: 0.85rem;
            font-weight: 500;
            text-align: right;
        }
    }
`

export const StatsSection = styled(Box)`
    background: #f3f8ff;
    border: 1px solid #dfe9f7;
    border-radius: 12px;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
`

export const StatsSectionHeader = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
`

export const StatsGrid = styled(Box)`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75rem;

    @media only screen and (max-width: 400px) {
        grid-template-columns: 1fr;
    }
`

export const StatCard = styled(Box)`
    background: #fff;
    border: 1px solid #e4ebf5;
    border-radius: 0.5rem;
    padding: 0.75rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    .stat-card-label {
        font-size: 0.8rem;
        color: rgba(0, 0, 0, 0.55);
        font-weight: 500;
    }

    .stat-card-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.25rem;
    }

    .stat-card-current {
        font-size: 0.875rem;
        color: rgba(0, 0, 0, 0.87);
    }

    .stat-card-projected {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        font-size: 0.85rem;
        font-weight: 600;
        border-radius: 999px;
        padding: 0.18rem 0.48rem;
        background: #fde8e8;
        color: #FB7672 !important;
        line-height: 1;

        svg {
            font-size: 0.95rem;
            color: #FB7672 !important;
        }

        .stat-card-projected-value {
            color: #FB7672 !important;
        }
    }

    .stat-card-projected--neutral {
        background: transparent;
        padding: 0;
        color: rgba(0, 0, 0, 0.54);

        svg {
            color: rgba(0, 0, 0, 0.54);
        }

        .stat-card-projected-value {
            color: rgba(0, 0, 0, 0.54) !important;
        }
    }
`

export const StatsNote = styled(Box)`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    background-color: #e6effb;
    border: 1px solid #d9e4f5;
    border-radius: 0.5rem;
    padding: 0.6rem 0.75rem;
    margin-top: 0.75rem;
    font-size: 0.8rem;
    color: rgba(0, 0, 0, 0.55);
    line-height: 1.4;
`

export const ConsequencesSection = styled(Box)`
    border: 1px solid #e7ebef;
    border-radius: 12px;
    padding: 1rem 1.25rem;
    margin-bottom: 1.5rem;
`

export const ConsequenceItem = styled(Box)`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.5rem 0;

    .consequence-number {
        min-width: 1.5rem;
        height: 1.5rem;
        border-radius: 50%;
        background-color: #0B4598;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.75rem;
        font-weight: 600;
        flex-shrink: 0;
        margin-top: 0.1rem;
    }

    .consequence-content {
        display: flex;
        flex-direction: column;
        gap: 0.1rem;
    }

    .consequence-title {
        font-size: 0.875rem;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.87);
    }

    .consequence-desc {
        font-size: 0.8rem;
        color: rgba(0, 0, 0, 0.5);
        line-height: 1.45;
    }

    & + & {
        border-top: 1px dashed #e7ebef;
        margin-top: 0.25rem;
        padding-top: 0.85rem;
    }
`

export const MembershipNotice = styled(Box)`
    background: #eaf4ff;
    border: 1px solid #dcecff;
    border-radius: 12px;
    padding: 0.95rem 1rem;
    margin-bottom: 1.5rem;

    .notice-header {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.95rem;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 0.45rem;
    }

    ul {
        margin: 0;
        padding-left: 1.25rem;
    }

    li + li {
        margin-top: 0.25rem;
    }

    a {
        color: #0b4598;
        text-decoration: underline;
    }
`

export const ConfirmDialog = styled(Dialog)`
    .MuiBackdrop-root {
        background: rgba(39, 43, 51, 0.56);
    }

    .MuiDialog-paper {
        border-radius: 24px;
        max-width: 520px;
        width: calc(100% - 24px);
        overflow: hidden;
        box-shadow: 0 28px 60px rgba(15, 23, 42, 0.24);
        background: #fff;
    }
`

export const ConfirmDialogHeader = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.35rem;
    border-bottom: 1px solid #e6eaf0;
    background: #f6f8fb;

    .dialog-header-left {
        display: flex;
        align-items: center;
        gap: 0.65rem;
        font-weight: 600;
        font-size: 1rem;
        color: #697586;
    }
`

export const ConfirmDialogBody = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem 2rem 1.45rem;
    text-align: center;
    background: #fff;

    .dialog-icon {
        width: 108px;
        height: 108px;
        margin-bottom: 1.35rem;
    }

    .dialog-title {
        font-size: 1.45rem;
        font-weight: 700;
        color: #182230;
        margin-bottom: 0.85rem;
    }

    .dialog-desc {
        font-size: 1rem;
        color: #667085;
        line-height: 1.55;
        max-width: 380px;
    }

    @media only screen and (max-width: 480px) {
        padding: 1.6rem 1.35rem 1.15rem;

        .dialog-icon {
            width: 88px;
            height: 88px;
            margin-bottom: 1rem;
        }

        .dialog-title {
            font-size: 1.2rem;
            margin-bottom: 0.65rem;
        }

        .dialog-desc {
            font-size: 0.92rem;
            max-width: 300px;
        }
    }
`

export const ConfirmDialogActions = styled(Box)`
    display: flex;
    gap: 1rem;
    padding: 1.2rem 1.5rem 1.5rem;
    border-top: 1px solid #e6eaf0;
    background: #fff;

    @media only screen and (max-width: 480px) {
        gap: 0.75rem;
        padding: 1rem 1.1rem 1.1rem;
    }
`

export const PageActionButton = styled(Button)`
    min-width: 138px !important;
    height: 42px !important;
    border-radius: 10px !important;
    padding: 0 18px !important;
    text-transform: none !important;
    font-size: 0.95rem !important;
    font-weight: 600 !important;
    box-shadow: none !important;
`

export const ModalSecondaryButton = styled(Button)`
    flex: 1;
    height: 54px !important;
    border-radius: 18px !important;
    border: 2px solid #d8dee8 !important;
    color: #182230 !important;
    text-transform: none !important;
    font-size: 1rem !important;
    font-weight: 600 !important;
    background: #fff !important;
    box-shadow: none !important;
`

export const ModalPrimaryButton = styled(Button)`
    flex: 1;
    height: 54px !important;
    border-radius: 18px !important;
    color: #fff !important;
    background: #fb7672 !important;
    text-transform: none !important;
    font-size: 1rem !important;
    font-weight: 700 !important;
    box-shadow: none !important;
`
